import React from "react"
import tw from "twin.macro"
import Pulse from "react-reveal/Pulse"
import { useQueryParam, NumberParam } from "use-query-params"

/* Vertical Card Deck - Parameters:

variant: (Required) with-title | no-title
colorVariant: (Required) grey | yellow | white
icon: (Required) Image of the ICON 
body: Description
title: Only need if the variant is "with-title"

*/

const Card = ({
  colorVariant,
  icon,
  body,
  index,
  lastindex,
  title,
  variant,
  iconAlt,
  addedStyle
}) => {
  const greyBlock = tw`bg-grey`
  const whiteBlock = tw`bg-white`
  const yellowBlock = tw`bg-yellow`
  const blueBlock = tw`bg-blue`

  return (
    <div
      css={[
        tw`flex flex-col px-5 py-16 mb-5 lg:(flex-row p-8) `,
        colorVariant === "yellow" && yellowBlock,
        colorVariant === "grey" && greyBlock,
        colorVariant === "white" && whiteBlock,
        colorVariant === "blue" && blueBlock,
        index === 0 && tw`rounded-tl-regular`,
        index === lastindex && tw`rounded-br-regular`,
        addedStyle && addedStyle
      ]}
    >
      <div tw="pb-8 my-auto self-center lg:(pb-0 self-start)">
        <img
          src={icon}
          tw="my-auto w-28 lg:(w-24)"
          alt={iconAlt ? iconAlt : ""}
        />
      </div>

      {title &&
        <h3
          css={[
            tw`m-auto pb-8 text-left text-blue text-2xl font-bold leading-tight lg:(w-6/12 pb-0 ml-8 mr-5 text-left leading-tight)`,
            variant === "no-title" && tw`hidden`, colorVariant === "blue" && tw`text-white`, colorVariant === "white" && tw`text-blue`
          ]}
        >
          {title}
        </h3>
      }

      <div
        css={[
          variant === "with-title" &&
          tw`w-1/4 mx-auto pb-8 border-t-2 border-blue lg:(w-0 pb-0 border-l-2)`,
          variant === "no-title" && tw`hidden`, colorVariant === "blue" && tw`border-white`
        ]}
      ></div>

      <div
        css={[
          tw`m-auto text-left lg:(ml-8 mr-5 text-left text-base w-[calc(100% - 96px)])`,
          variant === "with-title" && tw`lg:(w-2/4)`, colorVariant === "blue" && tw`text-white`, colorVariant === "grey" && tw`text-blue`, colorVariant === "white" && tw`text-blue`, colorVariant === "yellow" && tw`text-blue`,
        ]}
      >
        {body}
      </div>
    </div>
  )
}

const VerticalCardDeck = ({ cardDataObj, variant, addedCardStyle }) => {
  const [reveal] = useQueryParam("reveal", NumberParam)

  return (
    <>
      {cardDataObj.map((card, index) => (
        <Pulse delay={500} duration={reveal} key={index}>
          <Card
            colorVariant={card.colorVariant}
            icon={card.icon}
            iconAlt={card.iconAlt}
            body={card.body}
            index={index}
            lastindex={cardDataObj.length - 1}
            title={variant === "with-title" && card.title}
            variant={variant}
            addedStyle={addedCardStyle}
          />
        </Pulse>
      ))}
    </>
  )
}

export default VerticalCardDeck
